<template>
  <section class="mobile-header-root">
    <div class="filters">
      <filter-select
        title="Откуда"
        modal-title="Выбор региона погрузки"
        :items="loadPoints"
        @set-filter="setLoadFilter"
      />
      <filter-select
        title="Куда"
        modal-title="Выбор пункта выгрузки"
        :items="unloadPoints"
        @set-filter="setUnloadFilter"
      />
      <filter-select
        title="Тип перевозки"
        modal-title="Выбор типа перевозки"
        :items="typeCodesFilters"
        @set-filter="setTypeFilter"
      />
    </div>
    <div class="view-type">
      <div
        :class="['view-type__button', { active: getTypeView }]"
        @click="toggleButton(true)"
      >
        <p>Списком</p>
        <p v-if="quantity" class="badge">{{ quantity }}</p>
      </div>
      <div
        :class="['view-type__button', { active: !getTypeView }]"
        @click="toggleButton(false)"
      >
        На карте
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { typeCodesFilters } from '@/datas/consts'
import FilterSelect from '@/components/Drivers/FilterSelect/FilterSelect'

export default {
  name: 'BidsFilter',
  components: {
    FilterSelect,
  },
  props: {
    quantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      listFilter: [],
      typeCodesFilters,
      typeCode: '',
      unloadFilter: [],
      loadFilter: [],
    }
  },
  computed: {
    ...mapGetters({
      getTypeView: 'bids/getTypeView',
      bids: 'bids/getBids',
      getBidsKladrs: 'bids/getBidsKladrs',
      getBidIdLanding: 'bids/getBidIdLanding',
    }),
    // список регионов отправки для фильтра
    loadPoints() {
      let allPoints = this.bids.map(item => ({
        label: item.load_point_region_id,
        title: item.load_point.split(',')[0],
      }))
      let uniquePoints = []

      allPoints.filter(item =>
        uniquePoints.find(uniqe => uniqe.label === item.label)
          ? false
          : uniquePoints.push(item),
      )

      return uniquePoints
    },
    // список мест выгрузки для фильтра
    unloadPoints() {
      let allPoints = this.bids.map(item => ({
        label: item.unload_point_city_id,
        title: item.unload_point.split(',')[1],
      }))
      let uniquePoints = []

      allPoints.filter(item =>
        uniquePoints.find(uniqe => uniqe.label === item.label)
          ? false
          : uniquePoints.push(item),
      )

      return uniquePoints
    },
    currentFilterState() {
      let filter = {}

      if (this.typeCode.length) {
        filter.type_code = this.typeCode
      }

      if (this.unloadFilter.length) {
        filter.unload_city_id = this.unloadFilter
      }

      if (this.loadFilter.length) {
        filter.load_region_id = this.loadFilter
      }

      return filter
    },
  },
  methods: {
    ...mapMutations('bids', [
      'updateTypeView',
    ]),
    toggleButton(view) {
      if (view !== this.getTypeView) {
        this.updateTypeView()
      }
    },
    setLoadFilter(result) {
      this.loadFilter = (result.length) ? result : []
      this.$emit('filter-changed', this.currentFilterState)
    },
    setUnloadFilter(result) {
      this.unloadFilter = (result.length) ? result : []
      this.$emit('filter-changed', this.currentFilterState)
    },
    setTypeFilter(result) {
      if (result.length === this.typeCodesFilters.length || !result.length) {
        this.typeCode = ''
      } else {
        this.typeCode = result[0]
      }
      this.$emit('filter-changed', this.currentFilterState)
    },
  },
}
</script>

<style lang="sass" scoped>
@import "~@/assets/styles/mixins.sass"
.mobile-header-root
  position: fixed
  top: 0
  left: 0
  right: 0
  z-index: 100
  background: transparent

  .filters
    display: flex
    justify-content: space-between
    align-items: center
    height: 6.2rem
    padding: 0 1.6rem
    background: #FFFFFF
    box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)

  .view-type
    display: flex
    justify-content: space-between
    align-items: center
    height: 4.2rem
    margin: 1.5rem 1.6rem 0
    padding: 0 .4rem
    background: #FFFFFF
    border-radius: .8rem
    box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15)

    &__button
      display: flex
      justify-content: center
      align-items: center
      width: 16.4rem
      height: 3.4rem
      font-size: 1.4rem
      font-weight: 700
      line-height: 1.8rem
      border: none
      border-radius: .8rem
      background: #FFFFFF
      color: #5C5C5C
      cursor: pointer
      &:hover
        background: #00833C
        color: #FFFFFF
      &:active
        color: #FFFFFF
        background: #006421

      &.active
        background: $mainColor
        color: #FFFFFF

      .badge
        width: fit-content
        margin-left: 1.2rem
        padding: .3rem .4rem .2rem
        font-size: 1.2rem
        line-height: 1.6rem
        font-weight: 700
        background: #FF7F37
        color: #FFFFFF
        border-radius: .4rem
</style>
